// @mui
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import LinkItem from './link-item';
import { CustomBreadcrumbsProps } from './types';
import { Grid, SvgIcon, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DotGrillIcon, ListBoldIcon } from '../../assets';
import { VIEW_OPTIONS } from '../../constants';

// ----------------------------------------------------------------------

export default function CustomBreadcrumbs({
  links,
  action,
  heading,
  moreLink,
  activeLast,
  sx,
  lastLinkFlag = true,
  viewMode,
  handleViewChange,
  ...other
}: Readonly<CustomBreadcrumbsProps>) {
  const lastLink = links[links.length - 1]?.name;

  return (
    <Box sx={{ ...sx }}>
      <Stack direction="row" alignItems="center">
        <Box sx={{ flexGrow: 1 }}>
          {/* HEADING */}
          {heading && (
            <Typography variant="h4" gutterBottom>
              {heading}
            </Typography>
          )}

          {/* BREADCRUMBS */}
          {!!links.length && (
            <Breadcrumbs separator={<Separator />} {...other}>
              {links.map((link) => (
                <LinkItem
                  key={link.name ?? ''}
                  id={link.name ?? ''}
                  link={link}
                  activeLast={activeLast}
                  disabled={lastLinkFlag ? link.name === lastLink : lastLinkFlag}
                />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}> {action} </Box>}
        {!!viewMode && (
          <Grid width="max-content">
            <ToggleButtonGroup size="small" exclusive value={viewMode} onChange={handleViewChange}>
              <ToggleButton value={VIEW_OPTIONS.TABLE_VIEW} size="small">
                <SvgIcon sx={{ height: 20, width: 20 }}>
                  <ListBoldIcon />
                </SvgIcon>
              </ToggleButton>
              <ToggleButton value={VIEW_OPTIONS.CARD_VIEW} size="small">
                <SvgIcon sx={{ height: 20, width: 20 }}>
                  <DotGrillIcon />
                </SvgIcon>
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        )}
      </Stack>
      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link key={href} href={href} variant="body2" target="_blank" rel="noopener" sx={{ display: 'table' }}>
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}

// ----------------------------------------------------------------------

function Separator() {
  return <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'text.disabled' }} />;
}
